import { MUIIcon, ProgressIndicator } from "../../widgets"
import { UserRoleType, useAuth } from "../../../modules/auth"

import { ContactCard } from "./ContactCard"
import React, { useEffect, useState } from "react"
import { useContactConnections } from "./useContactConnections"
import { useSwitchUserEntityMutation } from "../../services/auth"

export const SwitchSiteEntity = ({ children }: { children?: React.ReactNode }) => {
    const { user } = useAuth()

    if (!user) {
        return <><ProgressIndicator /></>
    }

    switch (user.role) {
        case UserRoleType.Father:
        case UserRoleType.Mother:
        case UserRoleType.Guardian:
            return <SelectContactConnection>{children}</SelectContactConnection>
        default:
            return <>{children}</>
    }
}

export const SelectContactConnection = ({ children }: { children?: React.ReactNode }) => {
    const { user, siteId } = useAuth()
    const { connections, entityId, selectEntityId , loading} = useContactConnections()
    const [connectionId, setConnectionId] = useState<string | null>(null);
    const [loadingContactId, setLoadingContactId] = useState<string | null>(null);
    const [switchUserEntity] = useSwitchUserEntityMutation();

    useEffect(() => {
        if (!user || !siteId || !connectionId) return;

        setLoadingContactId(connectionId);
        switchUserEntity({ userName: user.userName, switchUserEntityId: connectionId, portalId: siteId })
            .unwrap()
            .then(() => {
                selectEntityId(connectionId);
            })
            .catch((err) => {
                console.error('An error occurred while switching user entity:', err);
            })
            .finally(() => {
                setLoadingContactId(null);
                setConnectionId(null);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId]);

    if (loading) {
        return <><ProgressIndicator /></>;
    }

    if (!entityId && connections) {
        return (
            <>
                <h1 className="mb-5">
                    <MUIIcon iconName="PersonSearchOutlined" className="fs-2x" /> Pick a Profile
                </h1>
                <div className="d-flex flex-row flex-wrap gap-3">
                    {connections.map((connection) => (
                        <button
                            key={connection.id}
                            type="button"
                            className="btn p-0 m-0"
                            onClick={() => setConnectionId(connection.contactId)}
                        >
                            <ContactCard
                                loadingContactId={loadingContactId}
                                className="btn btn-light"
                                contactId={connection.contactId}
                            />
                        </button>
                    ))}
                </div>
            </>
        );
    }

    if (!entityId) {
        return <><ProgressIndicator /></>;
    }

    return <>{children}</>;
};



